import "./Headings.scss";

export function MidPageHeading({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`mid-page-heading ${className}`}>{children}</div>;
}
